import { ButtonLink, ButtonLinkProps, cn } from "@vixi/ui";
import { useTranslation } from "@vixi/localization";
import { ComponentProps } from "react";
import { useUiStore } from "@vixi/ui";

// Assets
import LogoCompact from "@assets/sidebar-brand-compact.png";

export const SidebarBrand = () => {
  const { mode } = useUiStore((state) => state.sidebar);
  const { tFile } = useTranslation();

  if (mode === "compact") {
    return (
      <img
        src={LogoCompact}
        style={{ objectFit: "contain", height: "100%", width: "37px", marginInline: "auto" }}
      />
    );
  }

  return (
    <img
      src={tFile("/images/logos/", "sidebar-brand.svg")}
      style={{ objectFit: "contain", height: "100%", width: "100%" }}
    />
  );
};

export interface SidebarNavListProps {
  mode: "compact" | "expanded";
}

export const GoPremiumRoot = (props: ComponentProps<"div">) => (
  <div
    {...props}
    className="flex min-h-16.25 gap-2 border-y-2 border-t-2 border-black/16 text-center"
  />
);

export const GoPremiumLink = ({ className, ...props }: ButtonLinkProps) => {
  return (
    <ButtonLink
      className={cn(
        "flex w-full min-w-0 items-center justify-center gap-2 rounded-none p-0",
        className,
      )}
      {...props}
    />
  );
};
